import { Loader2, RefreshCw } from "lucide-react";

import { Button } from "@/common/ui/button";

interface FeedbackToolbarProps {
  isLoading: boolean;
  lastRefreshedAt: Date | null;
  onRefresh: () => void;
}

function formatLastRefreshed(date: Date | null): string {
  if (!date) return "";
  return `Updated ${date.toLocaleTimeString()}`;
}

export function FeedbackToolbar({
  isLoading,
  lastRefreshedAt,
  onRefresh,
}: FeedbackToolbarProps): React.ReactElement {
  return (
    <div data-testid="feedback-toolbar" className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {lastRefreshedAt && (
          <span data-testid="last-refreshed" className="text-sm text-muted-foreground">
            {formatLastRefreshed(lastRefreshedAt)}
          </span>
        )}
      </div>
      <Button
        data-testid="refresh-button"
        variant="outline"
        size="sm"
        onClick={onRefresh}
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <RefreshCw className="h-4 w-4" />
        )}
        Refresh
      </Button>
    </div>
  );
}
